import './Loader.css'
export default function Loader() {
  return (
    <div className='h-full w-full flex justify-center items-center'>
      <span className='loader'></span>
    </div>
  );
}
